import React from "react" // eslint-disable-line no-unused-vars -- this is always needed for the entrypoint
import {createRoot} from "react-dom/client"
import {AuthForm} from 'js/studios/shared/reg'
import {Provider} from 'react-redux'
import "./reducers"

function success(resp) {
  window.location = (resp && resp.postLoginUrl) || "/studios/account"
}

createRoot(document.getElementById('login_wrapper')).render(
  <Provider store={window.cm.store}><AuthForm onSuccess={success}/></Provider>
)
